import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function FrequentlyAskedMainPage() {
  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>آیا برنامه نسخه موبایل نیز دارد؟</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography>
            بله با کلیک بر روی لینک زیر می توانید نسخه موبایل برنامه را دریافت
            کنید:
          </Typography>
          <a target="_blank" href="https://app.umlang.com/">
            <Typography>دریافت اپلیکیشن موبایل</Typography>
          </a>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>برنامه دارای چه امکاناتی است؟</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography>- نمایش دو زیرنویس همزمان</Typography>
          <Typography>- دیکشنری پاپ آپ</Typography>
          <Typography>- ذخیره سریع</Typography>
          <Typography>- ذخیره پیشرفته لغات واصطلاحات</Typography>
          <Typography>- مرور لغات به روش SRS در لایتنر</Typography>
          <Typography>
            - امکان مشاهده ترجمه،تلفظ ، نمونه کاربرد و ... با استفاده از بهترین
            دیکشنری های آنلاین
          </Typography>
          <Typography>
            - اجرای آسان تکنیک محبوب و کاربردی سایه (Shadowing)
          </Typography>
          <Typography>- هایلایت لغات در حال یادگیری</Typography>
          <Typography>- هایلایت لغات سخت</Typography>
          <Typography>
            - هایلایت لغات بر اساس سطح بندی استاندارد (CEFR) ( در نسخه اولیه
            برنامه زبان انگیسی پشتیبانی می شود)
          </Typography>
          <Typography>- تغییر بک گراند لغات درحال یادگیری</Typography>
          <Typography>- تغییر بک گراند لغات سخت</Typography>
          <Typography>
            - تغییر بک گراند بر اساس سطح بندی استاندارد (CEFR) (زبان انگیسی)
          </Typography>
          <Typography>
            - توقف فیلم به مدت دلخواه در صورت وجود کلمات آماده مرور
          </Typography>
          <Typography>
            - توقف فیلم به مدت دلخواه در صورت وجود کلمات سخت
          </Typography>
          <Typography>
            - توقف فیلم به مدت دلخواه در صورت وجود کلمات سطح بندی شده (CEFR)
            (زبان انگیسی)
          </Typography>
          <Typography>
            - تکرار دیالوگ به دفعات قابل تنظیم در صورت وجود کلمات آماده مرور
          </Typography>
          <Typography>
            - تکرار دیالوگ به دفعات قابل تنظیم در صورت وجود کلمات سخت
          </Typography>
          <Typography>
            - تکرار دیالوگ به دفعات قابل تنظیم در صورت وجود کلمات سطح بندی شده
            (CEFR) (زبان انگیسی)
          </Typography>
          <Typography>
            - عدم وابستگی به سرعت اینترنت ( اول فیلمو با خیال راحت دانلود کن
            بعدا بدون دغدغه تماشاش کن و زبان یاد بگیر)
          </Typography>
          <Typography>- امکان هماهنگ سازی زیرنویس ها</Typography>
          <Typography>- تغییر فونت زیرنویس اول و دوم</Typography>
          <Typography>- تغییر رنگ زیرنویس اول و دوم</Typography>
          <Typography>- تغییر بک گراند زیرنویس اول و دوم</Typography>
          <Typography>- ابجایی آسان زیرنویس اول و دوم</Typography>
          <Typography>- اجرای تکنیک سایه(نسخه موبایل)</Typography>
          <Typography>
            - امکان مشاهده بروز ترین فیلم ها و سریال های دنیا
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>آیا برنامه رایگان است؟</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography>
            هدف از انتشار این نسخه ارائه یک
            <strong> برنامه رایگان </strong> و تکمیل برنامه می باشد.
          </Typography>
          <Typography>
            سه روش برای استفاده از تمامی امکانات برنامه وجود دارد:
          </Typography>
          <Typography>
            دو روش دریافت اشتراک رایگان برای کمک به پیشرفت در برنامه
          </Typography>
          <Typography>
            و یک روش خرید اشتراک برای کمک به رفع نیازهای برنامه
          </Typography>
          <Typography>
            - نکته: مبلغ پرداخت شده در روش سوم تماما صرف هزینه های برنامه می
            شود.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>فیلم صدا دارد اما تصویر ندارد؟</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography>
            وب اپلیکیشن اوملنگ از ویدئوپلیر اوملنگ استفاده می کند و به دلایل زیر
            ممکن است فیلم با ویدئوپلیر سازگاری نداشته باشد:
          </Typography>
          <Typography>
            <strong>کدک x265 و مرورگر قدیمی:</strong>
            <br />
            مرورگر گوگل کروم از ورژن 107 به بعد از کدک x265 پشتیبانی میکند پس در
            ابتدا مرورگر خود را آپدیت کنید.
            <br />
            برای دیکد کدک x265 نیاز به سخت افزار مناسب(cpu جدید)نیز می
            باشد.البته نرم افزارهای پخش فیلم در صورت نبود سخت افزار مناسب از
            دیکدر نرم افزاری نیز برای این منظور استفاده میکنند که فشار بیشتری بر
            روی cpu و در نتیجه مصرف برق بالاتر خواهد بود ، اما فعلا مرورگر ها
            این عمل را انجام نداده اند.
            <br />
            <strong>فرمت متفرقه </strong>
            <br />
            حتما از فیلم هایی با فرمت های استاندارد و پرکاربرد مثل mp4 ، avi ،
            mkv و ... استفاده کنید.
            <br />
            <strong>-معرفی بهترین فرمت و کدک:</strong>
            <br />
            بهترین فرمت برای پخش فیلم در برنامه mp4 و سازگارترین کدک نیز x264 می
            باشد.
            <br />
            شما نیز می توانید هر فیلمی را با نرم افزارهای مختلف مانند Total
            Video Converter یا Any Video Converter به فرمت قابل پخش در برنامه
            تبدیل کنید.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography>
            چرا فیلم بصورت آنلاین در برنامه گذاشته نشده است و از کجا فیلم دانلود
            کنم؟
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography>
            <strong>
              به 6 دلیل فیلم بصورت مستقیم و آنلاین در برنامه قرار داده نشده است:
            </strong>
          </Typography>
          <Typography>
            <br />
            <strong>1- وجود تعداد بسیار زیاد سایت های تخصصی دانلود فیلم</strong>
            <br />
            با وجود داشتن اینهمه سایت زبان آموز می تواند از هر منبعی که دوست
            دارد فیلم را دانلود و تهیه کند.
          </Typography>
          <Typography>
            <br />
            <strong>2- امکان مشاهده جدیدترین و بهترین فیلم ها</strong>
            <br />
            اگر فیلم توسط سایت ارائه میشد زبان آموز محدود به تماشای فیلم های
            ارائه شده در برنامه بود و هیچگاه یک برنامه نمی تواند از هزاران سایتی
            که فعال هستند سریعتر باشد و همچنین انتشار فیلم در برنامه باعث
            محدودیت در تنوع فیلم میشد.
          </Typography>
          <Typography>
            <br />
            <strong>3- صرفه جویی در هزینه های زبان آموز</strong>
            <br />
            در صورت پخش فیلم بصورت آنلاین در سایت مقدار زیادی از بسته اینترنت
            زبان آموز مصرف میشد و با هر بار تکرار فیلم نیز نیاز به دانلود مجدد
            دیتا است. اما با روش اوملنگ زبان آموز می تواند فیلم را از هر جایی و
            در هر زمانی (مثلا با فلش از دوستان یا در زمان داشتن بسته اینترنت
            رایگان و بصرفه) دریافت کند.
          </Typography>
          <Typography>
            <br />
            <strong>4- عدم وابستگی به سرعت اینترنت</strong>
            <br />
            در صورت پخش فیلم بصورت آنلاین ، زبان آموز حتما باید اینترنت با سرعت
            مناسب در اختیار داشته باشد اما با روش ما این مشکل برطرف گردیده است.
            این مشکل برای دانشجویانی که در طول سفر فیلم تماشا میکنند بسیار محسوس
            تر است.
          </Typography>
          <Typography>
            <br />
            <strong>5- تنوع سنی متفاوت زبان آموزان</strong>
            <br />
            در صورت انتشار فیلم ما نمی توانستیم فیلم مناسب با رده سنی های
            گوناگون را منتشر کنیم ، اما زبان آموز می تواند با توجه به رده سنی و
            سیلقه خود فیلم مناسب را از سایتهای مختلف دانلود کند
          </Typography>

          <Typography>
            <br />
            <strong>6- قوانین کپی رایت</strong>
            <br />
            انتشار فیلم در سایت نیاز به مجوز از سازنده فیلم می باشد و بدون توجه
            به قوانین کپی رایت امکان پخش فیلم وجود ندارد.
          </Typography>
          <hr />
          <Typography>
            برای دریافت فیلم نیز هیچگونه محدودیتی وجود ندارد و شما می توانید از
            سایت های مختلف مانند دیجی موویز ، زرفیلم ، کینگ مووی ، نایت مووی و
            ... فیلم را دریافت کنید و یا اگر دوستانتان فیلم را قبلا دانلود کرده
            اند از آنها بگیرید.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography> چطور به فیلم زیرنویس اضافه کنم؟</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ textAlign: "left" }}>
          <Typography>به دو روش می توان به فیلم زیرنویس اضافه نمود</Typography>
          <Typography>
            <strong>1- جستجوی زیرنویس در سایت</strong>
            <br />
            در حال حاظر نزدیک به 400 هزار زیرنویس برای فیلم ها و سریال های مختلف
            در سایت قرار دارد و شما می توانید از این زیرنویس ها استفاده کنید.
            <br />
          </Typography>
          <Typography>
            <strong>2- انتخاب زیرنویس از کامپیوتر یا موبایل</strong>
            <br />
            اگر چنانچه شما زیرنویس های فیلم را از قبل دارید می توانید آنها را
            انتخاب کنید.
            <br />
            و یا اگر زیرنویس مورد نظر خود را در بخش جستجوی سایت پیدا نکرده اید
            می توانید با جستجو در گوگل از هزاران سایت فعال در این زمینه زیرنویس
            ها را دانلود و از آنها استفاده کنید
            <br />
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
